import { isEqual } from 'lodash'
import { condicaoMaternalRecord } from 'types/enums'
import { AtendimentoVacinacaoState } from 'view/atendimentos/atendimento-vacinacao/model'

import { OutraCondicaoKey, outrasCondicoesVacinacaoRecord, VacinacaoDirtyFieldsModel } from './model-vacinacao'

export function getDirtyFieldsVacinacao(
  initialValues: AtendimentoVacinacaoState,
  currentValues: AtendimentoVacinacaoState
): VacinacaoDirtyFieldsModel {
  const initialCondicoes = initialValues.condicoesVacinacao
  const currentCondicoes = currentValues.condicoesVacinacao

  const condicaoMaternal =
    initialCondicoes.condicao !== currentCondicoes.condicao
      ? condicaoMaternalRecord[currentCondicoes.condicao].defaultLabel
      : undefined

  const outrasCondicoes = (Object.keys(outrasCondicoesVacinacaoRecord) as OutraCondicaoKey[])
    .filter((key) => Boolean(initialCondicoes[key]) !== Boolean(currentCondicoes[key]))
    .map((key) => outrasCondicoesVacinacaoRecord[key])

  const initialRegistrosMap = new Map(initialValues.registroVacinacao.map((reg) => [reg.idUnicoRegistro, reg]))
  const currentRegistrosMap = new Map(currentValues.registroVacinacao.map((reg) => [reg.idUnicoRegistro, reg]))

  const imunosAlterados = currentValues.registroVacinacao
    .filter((currentRegistro) => {
      const initialReg = initialRegistrosMap.get(currentRegistro.idUnicoRegistro)
      return !initialReg || !isEqual(initialReg, currentRegistro)
    })
    .map((registro) => registro.imunobiologicoNome || registro.outrosImunosImunobiologico?.nome)

  const imunosRemovidos = initialValues.registroVacinacao
    .filter((initialRegistro) => !currentRegistrosMap.has(initialRegistro.idUnicoRegistro))
    .map((registro) => registro.imunobiologicoNome || registro.outrosImunosImunobiologico?.nome)

  const imunobiologicos = new Set([...imunosAlterados, ...imunosRemovidos])

  return {
    condicaoMaternal,
    outrasCondicoes,
    imunobiologicos,
  }
}
